var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [_vm._v("Hubspot authorisieren via OAuth")]),
          _c("v-card-subtitle", [
            _vm._v(
              " HubSpot authorisieren damit via Botformulare die Daten in einen Hubspot Lead übertragen werden können "
            ),
          ]),
          _c(
            "v-form",
            { ref: "form" },
            [
              _vm.isAdmin
                ? _c(
                    "v-col",
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "OAuth-URL",
                          placeholder: "OAuth-URL",
                          rules: _vm.rules.url,
                          disabled: true,
                        },
                        model: {
                          value: _vm.url,
                          callback: function ($$v) {
                            _vm.url = $$v
                          },
                          expression: "url",
                        },
                      }),
                      _c("p", { staticClass: "primary--text" }, [
                        _vm._v("Format: https://app.hubspot.com"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                [
                  _vm.isAdmin
                    ? _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("integrations.hubspot.scope"),
                          placeholder: "scope",
                          disabled: true,
                        },
                        model: {
                          value: _vm.scope,
                          callback: function ($$v) {
                            _vm.scope = $$v
                          },
                          expression: "scope",
                        },
                      })
                    : _c("h3", { staticClass: "text-h6 primary--text" }, [
                        _vm._v(_vm._s(_vm.$t("integrations.hubspot.scope"))),
                      ]),
                  _c(
                    "v-row",
                    { staticClass: "mx-1 d-flex gap-3" },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Contacts v1" },
                        on: { change: (v) => _vm.handleScope("contactsV1", v) },
                        model: {
                          value: _vm.scopeState.contactsV1,
                          callback: function ($$v) {
                            _vm.$set(_vm.scopeState, "contactsV1", $$v)
                          },
                          expression: "scopeState.contactsV1",
                        },
                      }),
                      _c("v-checkbox", {
                        attrs: { label: "Contacts v3" },
                        on: { change: (v) => _vm.handleScope("contactsV3", v) },
                        model: {
                          value: _vm.scopeState.contactsV3,
                          callback: function ($$v) {
                            _vm.$set(_vm.scopeState, "contactsV3", $$v)
                          },
                          expression: "scopeState.contactsV3",
                        },
                      }),
                      _c("v-checkbox", {
                        attrs: { label: "Tickets" },
                        on: { change: (v) => _vm.handleScope("tickets", v) },
                        model: {
                          value: _vm.scopeState.tickets,
                          callback: function ($$v) {
                            _vm.$set(_vm.scopeState, "tickets", $$v)
                          },
                          expression: "scopeState.tickets",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "success",
                    dark: "",
                    small: "",
                    disabled: _vm.isLoading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.oauth()
                    },
                  },
                },
                [
                  _vm._v(" Auth "),
                  _c("v-icon", { attrs: { right: "", dark: "" } }, [
                    _vm._v("mdi-robot-love-outline"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { timeout: 6000 },
          model: {
            value: _vm.savingToast,
            callback: function ($$v) {
              _vm.savingToast = $$v
            },
            expression: "savingToast",
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-center" },
            [
              _c(
                "v-icon",
                {
                  staticClass: "mr-2",
                  attrs: { color: "green", type: "success" },
                },
                [_vm._v("check")]
              ),
              _c("div", [_vm._v("Oauth success")]),
            ],
            1
          ),
        ]
      ),
      _c(
        "v-snackbar",
        {
          attrs: { timeout: 6000 },
          model: {
            value: _vm.savingToastError,
            callback: function ($$v) {
              _vm.savingToastError = $$v
            },
            expression: "savingToastError",
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-center" },
            [
              _c("v-icon", { staticClass: "mr-2", attrs: { color: "red" } }, [
                _vm._v("mdi-alert-circle"),
              ]),
              _c("div", [
                _vm._v(_vm._s(_vm.message || _vm.$t("common.notSavedError"))),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }